import axios from 'axios';

const GEOLOCATION_URL = "https://nominatim.openstreetmap.org";
// Example
// 'https://nominatim.openstreetmap.org/reverse?format=json&lat=' + lat + '&lon=' + lon + '&addressdetails=1

export default {

  getLocation:(lat, lng) => {
    let api_url = `${GEOLOCATION_URL}/reverse?format=json&lat=${lat}&lon=${lng}&addressdetails=1`;
    return axios.get(api_url);
  },
  /**
   * https://nominatim.openstreetmap.org/search?format=json&q=7777+Mayfield+St%2C+Burnaby%2C+BC&polygon_geojson=1
   */
  getLocationByAddress(address) {
    const proxy = 'https://cors-anywhere.herokuapp.com/';
    let api_url = `${proxy}${GEOLOCATION_URL}/search?format=json&q=${address}&polygon_geojson=1`;
    return axios.get(api_url);
  }
}
